"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SExpression = void 0;
const IonTypes_1 = require("../IonTypes");
const JsValueConversion_1 = require("./JsValueConversion");
/**
 * Represents an s-expression[1] value in an Ion stream.
 *
 * [1] http://amzn.github.io/ion-docs/docs/spec.html#sexp
 */
class SExpression extends (0, JsValueConversion_1.Sequence)(IonTypes_1.IonTypes.SEXP) {
    /**
     * Constructor.
     * @param children      Values that will be contained in the new s-expression.
     * @param annotations   An optional array of strings to associate with the items in `children`.
     */
    constructor(children, annotations = []) {
        super(children, annotations);
    }
    toString() {
        return "(" + this.join(" ") + ")";
    }
}
exports.SExpression = SExpression;
